import { render } from "./VaBeneSupplementListPage.vue?vue&type=template&id=217f7bfe&ts=true"
import script from "./VaBeneSupplementListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneSupplementListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__